function gssQty(btn, d, key) {
  var inp = btn.parentElement.querySelector('.gss-qty-input');
  var v = Math.max(0, parseInt(inp.value) + d);
  inp.value = v;
  fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: v }) }).then(function () { location.reload(); });
}
function gssRemove(key) {
  fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }).then(function () { location.reload(); });
}
